export const ariaLabels = {
  HEADER: {
    PROFILE_PICTURE_ICON_BUTTON: 'Open profile menu',
  },
}

export const ariaLabelAttribute = (label: string) => ({
  'aria-label': label,
})
